import { useMemo } from 'react';

import { DAY_TYPES, EMPTY_TIME_RANGE } from '~/constants/organization_business_hour';
import { GetWebBookingsSettingQuery } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { resolveBusinessHours } from '~/utils/organization_business_hour';

import { Fields } from '../types';

export const useInitialValues = (data: GetWebBookingsSettingQuery | undefined): Fields => {
  return useMemo<Fields>(() => {
    const organization = data ? getMe(data)?.organization : null;
    const setting = organization?.webBookingsSetting ?? null;
    const businessHourSources = resolveBusinessHours(
      organization?.organizationBusinessHours,
      organization?.organizationMasterMedicalInformationNet?.organizationBusinessHours,
    );

    return {
      published: setting?.published ? 'publish' : 'unpublish',
      facetoface: setting?.facetoface ? 'enabled' : 'disabled',
      telemedicine: setting?.telemedicine ? 'enabled' : 'disabled',
      description: setting?.description || '',
      website: setting?.website || '',
      openingHours: setting?.openingHours || '',
      logo: undefined,
      onlineQualificationConfirmation: setting?.onlineQualificationConfirmation
        ? 'enabled'
        : 'disabled',
      onlineQualificationConfirmationUrl: setting?.onlineQualificationConfirmationUrl || '',
      businessHours: DAY_TYPES.map((day) => {
        const existing = businessHourSources.filter(
          (businessHour) => businessHour.dayType === day.key,
        );
        if (existing.length === 0) {
          return {
            dayType: day.key,
            enabled: false,
            timeRanges: [{ ...EMPTY_TIME_RANGE }],
          };
        }
        const timeRanges = existing.map((businessHour) => {
          const [startHour = '--', startMinute = '--'] = (businessHour.startTime || '').split(':');
          const [endHour = '--', endMinute = '--'] = (businessHour.endTime || '').split(':');
          return {
            organizationBusinessHourId: businessHour.id,
            startHour,
            startMinute,
            endHour,
            endMinute,
          };
        });
        return {
          dayType: day.key,
          enabled: true,
          timeRanges,
        };
      }),
    };
  }, [data]);
};
